import React from "react";
import {
  Control,
  Dot,
  HiddenInput,
  Label,
  Ring,
  Wrapper,
} from "./RadioOption.styles";
import type { RadioOptionProps } from "./RadioOption.types";

/**
 * Single radio in a group — ring plus filled centre dot, with a visible label.
 *
 * Wraps a real `<input type="radio">` rather than faking one with `role`, so
 * arrow-key roving, form semantics and screen-reader announcements come for
 * free; the styled `Ring`/`Dot` are decoration layered on top.
 *
 * Stateless: the parent owns which value is selected.
 */
export const RadioOption: React.FC<RadioOptionProps> = ({
  name,
  value,
  checked,
  label,
  disabled = false,
  onChange,
  className,
}) => (
  <Wrapper $disabled={disabled} className={className}>
    <Control>
      <HiddenInput
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={() => onChange(value)}
      />
      <Ring $checked={checked} aria-hidden>
        <Dot $checked={checked} />
      </Ring>
    </Control>
    <Label>{label}</Label>
  </Wrapper>
);

export default RadioOption;
